import React from 'react'
import { FiEdit } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import "./ServicesTable.css"
const ServicesTable = ({data}) => {
  console.log("DATA",data)
    const navigate=useNavigate()
    const handleEditClick = (service) =>{
        navigate(`/services-pricing/${service?.id}`)
        console.log("Edit Click")
    }
  return (
    <div className="quote-table-wrapper">
      <table className="quote-table">
        <thead>
          <tr>
            <th className="td-sr">Sr.</th>
            <th>Service Name</th>
            <th>Pricing Section</th>
            <th>Action</th>
           
          </tr>
        </thead>

        <tbody>
          {data.map((item, index) => (
            <tr key={item.id}>
              <td className="td-sr">{index + 1}</td>
              <td>{item.serviceName}</td>
              <td>{`${item.isAdditionalServices===true ? "Yes" : "No"}`}</td>
              

                 <td>
                <button
                  className="chat-btn service-edit-btn"
                  onClick={() => handleEditClick(item)}
                  title="Edit Booking"
                   disabled={!item.isAdditionalServices}
                >
                  <FiEdit size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default ServicesTable